import { cn } from "@/utils/cn";
import { memo } from "react";

interface EyeOnIconProps {
  className?: string;
}

export const EyeOnIcon = memo(function EyeOnIcon({
  className,
}: EyeOnIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={cn("fill-icons-input-default", className)}
    >
      <path
        d="M15.9569 7.7975C15.935 7.74813 15.4056 6.57375 14.2287 5.39687C12.6606 3.82875 10.68 3 8.49999 3C6.31999 3 4.33937 3.82875 2.77124 5.39687C1.59437 6.57375 1.06249 7.75 1.04312 7.7975C1.01469 7.86144 1 7.93064 1 8.00062C1 8.0706 1.01469 8.1398 1.04312 8.20375C1.06499 8.25312 1.59437 9.42688 2.77124 10.6038C4.33937 12.1713 6.31999 13 8.49999 13C10.68 13 12.6606 12.1713 14.2287 10.6038C15.4056 9.42688 15.935 8.25312 15.9569 8.20375C15.9853 8.1398 16 8.0706 16 8.00062C16 7.93064 15.9853 7.86144 15.9569 7.7975ZM8.49999 12C6.57624 12 4.89562 11.3006 3.50437 9.92188C2.93352 9.35418 2.44786 8.70685 2.06249 8C2.44776 7.29309 2.93343 6.64574 3.50437 6.07812C4.89562 4.69938 6.57624 4 8.49999 4C10.4237 4 12.1044 4.69938 13.4956 6.07812C14.0676 6.6456 14.5543 7.29295 14.9406 8C14.49 8.84125 12.5269 12 8.49999 12ZM8.49999 5C7.90665 5 7.32663 5.17595 6.83328 5.50559C6.33994 5.83524 5.95542 6.30377 5.72836 6.85195C5.50129 7.40013 5.44188 8.00333 5.55764 8.58527C5.67339 9.16721 5.95912 9.70176 6.37867 10.1213C6.79823 10.5409 7.33278 10.8266 7.91472 10.9424C8.49667 11.0581 9.09987 10.9987 9.64804 10.7716C10.1962 10.5446 10.6648 10.1601 10.9944 9.66671C11.324 9.17336 11.5 8.59334 11.5 8C11.4992 7.2046 11.1828 6.44202 10.6204 5.87959C10.058 5.31716 9.29539 5.00083 8.49999 5ZM8.49999 10C8.10443 10 7.71775 9.8827 7.38885 9.66294C7.05996 9.44318 6.80361 9.13082 6.65224 8.76537C6.50086 8.39991 6.46125 7.99778 6.53842 7.60982C6.61559 7.22186 6.80608 6.86549 7.08578 6.58579C7.36549 6.30608 7.72185 6.1156 8.10981 6.03843C8.49778 5.96126 8.89991 6.00087 9.26536 6.15224C9.63081 6.30362 9.94317 6.55996 10.1629 6.88886C10.3827 7.21776 10.5 7.60444 10.5 8C10.5 8.53043 10.2893 9.03914 9.91421 9.41421C9.53913 9.78929 9.03043 10 8.49999 10Z"
        fill="#7485A7"
      />
    </svg>
  );
});
